import { Dialog, Toast } from "antd-mobile";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import PsContext from "../../context";
import { integerIndPincode, momentDate } from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";

const StepTwo = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);

  const [permanent_doorno, setPermanent_DoorNo] = useState("");
  const [permanent_street, setPermanent_Street] = useState("");
  const [permanent_city, setPermanent_City] = useState("");
  const [permanent_taluk, setPermanent_Taluk] = useState("");
  const [permanent_district, setPermanent_District] = useState("");
  const [permanent_state, setPermanent_State] = useState("");
  const [permanent_country, setPermanent_Country] = useState("");
  const [permanent_pincode, setPermanent_Pincode] = useState("");

  const [present_doorno, setPresent_DoorNo] = useState("");
  const [present_street, setPresent_Street] = useState("");
  const [present_city, setPresent_City] = useState("");
  const [present_taluk, setPresent_Taluk] = useState("");
  const [present_district, setPresent_District] = useState("");
  const [present_state, setPresent_State] = useState("");
  const [present_country, setPresent_Country] = useState("");
  const [present_pincode, setPresent_Pincode] = useState("");

  useEffect(() => {
    if (props.dataSource) {
      setPermanent_DoorNo(props.dataSource.doorno_permanent);
      setPermanent_Street(props.dataSource.street_permanent);
      setPermanent_City(props.dataSource.village_permanent);
      setPermanent_Taluk(props.dataSource.taluk_permanent);
      setPermanent_District(props.dataSource.district_permanent);
      setPermanent_State(props.dataSource.state_permanent);
      setPermanent_Country(props.dataSource.country_permanent);
      setPermanent_Pincode(props.dataSource.pincode_permanent);

      setPresent_DoorNo(props.dataSource.doorno_present);
      setPresent_Street(props.dataSource.street_persent);
      setPresent_City(props.dataSource.village_present);
      setPresent_Taluk(props.dataSource.taluk_present);
      setPresent_District(props.dataSource.district_present);
      setPresent_State(props.dataSource.state_present);
      setPresent_Country(props.dataSource.country_present);
      setPresent_Pincode(props.dataSource.pincode_present);
    }
  }, [props.dataSource]);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() == false) {
      e.stopPropagation();
      setValidated(true);
      Toast.show({ content: "Please fill all the required fields" });
      return;
    }
    Dialog.confirm({
      content: "Do you want to update?",
      confirmText: "Yes",
      cancelText: "No",
      onConfirm: async () => {
        updateProfilee(form);
      },
    });
  };

  const updateProfilee = (form) => {
    context.setLoader(true);
    axios
      .post(ServiceUrl.STUDENTS.UPDATE_PROFILE_STEP_TWO, new FormData(form))
      .then((res) => {
        if (res["data"].status == "1") {
          if (props.onSuccess) props.onSuccess();
          Toast.show({
            content: res["data"].message || "Updated",
            icon: "success",
          });
          context.setStorage("setp_two", "yes");
        } else {
          Toast.show({ content: res["data"].message || "Error" });
        }
        context.setLoader(false);
      });
  };

  const maxDate = () => {
    let y = momentDate(new Date(), "YYYY") - 16;
    let d = momentDate(new Date(), "DD");
    let m = momentDate(new Date(), "MM");
    return momentDate(y + "-" + m + "-" + d, "YYYY-MM-DD");
  };

  const studentData = (fieldName) => {
    let d = context.getStorage("update_stu_data");
    if (d) d = JSON.parse(d);
    return d?.[fieldName];
  };

  const handleSwitchChange = (e) => {
    if (e.target.checked) {
      setPresent_DoorNo(permanent_doorno);
      setPresent_Street(permanent_street);
      setPresent_City(permanent_city);
      setPresent_Taluk(permanent_taluk);
      setPresent_District(permanent_district);
      setPresent_State(permanent_state);
      setPresent_Country(permanent_country);
      setPresent_Pincode(permanent_pincode);
    } else {
      setPresent_DoorNo("");
      setPresent_Street("");
      setPresent_City("");
      setPresent_Taluk("");
      setPresent_District("");
      setPresent_State("");
      setPresent_Country("");
      setPresent_Pincode("");
    }
  };

  const field = (fieldName) => {
    let m = props.dataSource;
    return m?.[fieldName];
  };

  return (
    <>
      <Form
        action=""
        method="post"
        noValidate
        validated={validated}
        onSubmit={handleFormSubmit}
      >
        <input type="hidden" name="uuid" value={studentData("uuid")} />
        <input
          type="hidden"
          name="registerno"
          value={studentData("registerno")}
        />

        <div className="bg-blue-100 text-primary fw-bold p-2 form-title-card">
          Permanent Address
        </div>
        <div className="container py-2">
          <Row className="">
            <Col md={4} sm={4} xs={4}>
              <label>
                Door No <span className="text-danger">*</span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="text"
                size="sm"
                className="fw-bold"
                name="doorno_permanent"
                value={permanent_doorno}
                onChange={(e) => setPermanent_DoorNo(e.target.value)}
                required
              />
            </Col>
          </Row>

          <Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                Street <span className="text-danger">*</span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="text"
                size="sm"
                className="fw-bold"
                name="street_permanent"
                value={permanent_street}
                onChange={(e) => setPermanent_Street(e.target.value)}
                required
              />
            </Col>
          </Row>

          <Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                City/Village <span className="text-danger">*</span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="text"
                size="sm"
                className="fw-bold"
                name="village_permanent"
                value={permanent_city}
                onChange={(e) => setPermanent_City(e.target.value)}
                required
              />
            </Col>
          </Row>

          <Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                Taluk <span className="text-danger">*</span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="text"
                size="sm"
                className="fw-bold"
                name="taluk_permanent"
                value={permanent_taluk}
                onChange={(e) => setPermanent_Taluk(e.target.value)}
              />
            </Col>
          </Row>

          <Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                District <span className="text-danger">*</span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="text"
                size="sm"
                className="fw-bold"
                name="district_permanent"
                value={permanent_district}
                onChange={(e) => setPermanent_District(e.target.value)}
                required
              />
            </Col>
          </Row>

          <Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                State <span className="text-danger">*</span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="text"
                size="sm"
                className="fw-bold"
                name="state_permanent"
                value={permanent_state}
                onChange={(e) => setPermanent_State(e.target.value)}
                required
              />
            </Col>
          </Row>

          <Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                Country <span className="text-danger">*</span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="text"
                size="sm"
                className="fw-bold"
                name="country_permanent"
                value={permanent_country}
                onChange={(e) => setPermanent_Country(e.target.value)}
                required
              />
            </Col>
          </Row>

          <Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                Pincode <span className="text-danger">*</span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="number"
                size="sm"
                className="fw-bold"
                name="pincode_permanent"
                onKeyPress={integerIndPincode}
                value={permanent_pincode}
                onChange={(e) => setPermanent_Pincode(e.target.value)}
                required
              />
            </Col>
          </Row>
        </div>

        <div className="bg-blue-100 text-primary fw-bold p-2 form-title-card">
          Present Address
          <span className="float-end">
            <Form.Check
              type="switch"
              id="custom-switch"
              label="Same as Permanent"
              onChange={(e) => handleSwitchChange(e)}
            />
          </span>
        </div>
        <div className="container py-2">
          <Row className="">
            <Col md={4} sm={4} xs={4}>
              <label>
                Door No <span className="text-danger">*</span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="text"
                size="sm"
                className="fw-bold"
                name="doorno_present"
                value={present_doorno}
                onChange={(e) => setPresent_DoorNo(e.target.value)}
                required
              />
            </Col>
          </Row>

          <Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                Street <span className="text-danger">*</span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="text"
                size="sm"
                className="fw-bold"
                name="street_present"
                value={present_street}
                onChange={(e) => setPresent_Street(e.target.value)}
                required
              />
            </Col>
          </Row>

          <Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                City/Village <span className="text-danger">*</span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="text"
                size="sm"
                className="fw-bold"
                name="village_present"
                value={present_city}
                onChange={(e) => setPresent_City(e.target.value)}
                required
              />
            </Col>
          </Row>

          <Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                Taluk <span className="text-danger">*</span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="text"
                size="sm"
                className="fw-bold"
                name="taluk_present"
                value={present_taluk}
                onChange={(e) => setPresent_Taluk(e.target.value)}
              />
            </Col>
          </Row>

          <Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                District <span className="text-danger">*</span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="text"
                size="sm"
                className="fw-bold"
                name="district_present"
                value={present_district}
                onChange={(e) => setPresent_District(e.target.value)}
                required
              />
            </Col>
          </Row>

          <Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                State <span className="text-danger">*</span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="text"
                size="sm"
                className="fw-bold"
                name="state_present"
                value={present_state}
                onChange={(e) => setPresent_State(e.target.value)}
                required
              />
            </Col>
          </Row>

          <Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                Country <span className="text-danger">*</span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="text"
                size="sm"
                className="fw-bold"
                name="country_present"
                value={present_country}
                onChange={(e) => setPresent_Country(e.target.value)}
                required
              />
            </Col>
          </Row>

          <Row className="mt-2">
            <Col md={4} sm={4} xs={4}>
              <label>
                Pincode <span className="text-danger">*</span>
              </label>
            </Col>
            <Col md={8} sm={8} xs={8}>
              <Form.Control
                type="number"
                size="sm"
                className="fw-bold"
                name="pincode_present"
                onKeyPress={integerIndPincode}
                value={present_pincode}
                onChange={(e) => setPresent_Pincode(e.target.value)}
                required
              />
            </Col>
          </Row>
        </div>

        <div className="container py-3">
          <Row>
            <Col md={12}>
              <Button
                type="submit"
                variant="warning"
                className="w-100"
                size="lg"
              >
                Save & Continue
              </Button>
            </Col>
          </Row>
        </div>
      </Form>
    </>
  );
};
export default StepTwo;
